import { resolveAssetUrl } from "../../resolveAssetUrl";
import { TextNodeType } from "../../CommonLandingMweb.types";
import {
  Card,
  CardInfo,
  CardTitle,
  Chevron,
  Container,
  List,
  PlanIcon,
  Separator,
  TagImg,
  TextBlock,
  Title,
  TitleRow,
} from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";

interface TravelPlanItem {
  title?: TextNodeType;
  info?: TextNodeType;
  type?: string;
  icon?: string | Record<string, unknown>;
  tagURL?: string | Record<string, unknown>;
}

interface TravelPlansProps {
  title?: TextNodeType;
  plans?: TravelPlanItem[];
  isVisible?: boolean;
  onPlanPress?: () => void;
}

export const TravelPlans = ({
  title,
  plans,
  isVisible = true,
  onPlanPress,
}: TravelPlansProps) => {
  if (!isVisible || !plans?.length) return null;

  return (
    <Container>
      <Separator />
      <Title>
        <FormattedText value={title} />
      </Title>
      <List>
        {plans.map((plan, index) => {
          const iconUrl = resolveAssetUrl(plan.icon);
          const tagUrl = resolveAssetUrl(plan.tagURL);
          return (
          <Card key={`${plan.type || "plan"}-${index}`} onClick={onPlanPress}>
            {iconUrl ? <PlanIcon src={iconUrl} alt="" /> : null}
            <TextBlock>
              <TitleRow>
                <CardTitle>
                  <FormattedText value={plan.title} />
                </CardTitle>
                {tagUrl ? <TagImg src={tagUrl} alt="" /> : null}
              </TitleRow>
              <CardInfo>
                <FormattedText value={plan.info} />
              </CardInfo>
            </TextBlock>
            <Chevron aria-hidden>›</Chevron>
          </Card>
          );
        })}
      </List>
    </Container>
  );
};
